<form [formGroup]="form">
  <div class="form-group" [class.required]="isFieldInvalidRequired()">
    <label [for]="ctrlName">
      {{label | translate }}</label>

    <input *ngIf="!inputMask" type="text" class="form-control" [id]="ctrlName"
           [formControlName]="ctrlName" [class.invalid]="isFieldInvalid()">

    <input *ngIf="inputMask" type="text" class="form-control" [id]="ctrlName"
           [mask]="inputMask"
           [formControlName]="ctrlName" [class.invalid]="isFieldInvalid()">
  </div>
</form>
